const carouselData = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20couple%20sharing%20earphones%20watching%20a%20tablet%20together%20in%20a%20cozy%20bedroom%2C%20warm%20fairy%20lights%20in%20background%2C%20soft%20golden%20hour%20lighting%2C%20cinematic%20atmosphere%2C%20intimate%20mood%2C%20cream%20and%20terracotta%20tones%2C%20editorial%20photography%2C%20dreamy%20aesthetic&width=1200&height=600&seq=carousel-01-sweet&orientation=landscape',
    tag: '甜宠专题',
    title: '甜蜜满分：情侣必刷甜宠剧合集',
    desc: '从校园到职场，从初恋到婚姻，精选国产剧中最甜的恋爱故事，每一部都能让你们的感情升温。',
    count: '48部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20couple%20sitting%20on%20a%20wooden%20bench%20in%20a%20Seoul%20park%20during%20autumn%2C%20colorful%20fall%20leaves%2C%20soft%20warm%20sunlight%2C%20Korean%20drama%20cinematic%20aesthetic%2C%20romantic%20composition%2C%20film%20photography%20style%2C%20cream%20and%20golden%20tones&width=1200&height=600&seq=carousel-02-korean&orientation=landscape',
    tag: '韩剧专题',
    title: '韩剧入坑指南：零差评经典全集',
    desc: '从《请回答1988》到《鬼怪》，韩剧全集中那些让人又哭又笑的神作，和TA一起体验韩剧的魅力。',
    count: '36部经典',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20couple%20in%20elegant%20traditional%20Chinese%20hanfu%20robes%20standing%20in%20a%20moonlit%20ancient%20garden%20with%20lanterns%2C%20soft%20romantic%20atmosphere%2C%20cinematic%20composition%2C%20warm%20golden%20lantern%20light%2C%20dreamy%20mood%2C%20film%20photography%2C%20terracotta%20and%20cream%20tones&width=1200&height=600&seq=carousel-03-costume&orientation=landscape',
    tag: '古装专题',
    title: '古装仙侠：一眼万年的东方浪漫',
    desc: '穿上汉服，穿越千年。情侣影院古装剧全集专题，从仙侠到宫斗，带你们领略最美的东方爱情故事。',
    count: '42部仙侠',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20room%20with%20a%20couple%20examining%20a%20mystery%20board%20with%20red%20strings%20and%20photos%2C%20warm%20desk%20lamp%20lighting%2C%20cinematic%20noir%20aesthetic%2C%20suspenseful%20atmosphere%2C%20amber%20and%20dark%20wood%20tones%2C%20film%20still%20photography&width=1200&height=600&seq=carousel-04-suspense&orientation=landscape',
    tag: '悬疑专题',
    title: '双人烧脑：高分悬疑剧全集',
    desc: '谁说情侣只能看甜剧？一起推理、一起猜测凶手，悬疑剧让追剧变成一场刺激的智力对决。',
    count: '28部高分',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20living%20room%20with%20a%20large%20TV%20screen%20showing%20vibrant%20colorful%20abstract%20visuals%2C%20a%20couple%20excited%20on%20the%20sofa%2C%20popcorn%20and%20snacks%20on%20coffee%20table%2C%20warm%20evening%20lighting%2C%20cinematic%20interior%2C%20cozy%20atmosphere%2C%20cream%20and%20beige%20tones&width=1200&height=600&seq=carousel-05-new&orientation=landscape',
    tag: '新剧专题',
    title: '最新电视剧追更日历：每周更新',
    desc: '不再错过任何一部热门新剧！情侣影院同步追更最新电视剧，每日更新，让你们的追剧节奏快人一步。',
    count: '每日更新',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20young%20couple%20in%20school%20uniforms%20sitting%20on%20a%20sunny%20campus%20lawn%20reading%20a%20book%20together%2C%20cherry%20blossom%20trees%2C%20soft%20spring%20sunlight%2C%20youthful%20romantic%20atmosphere%2C%20cinematic%20photography%2C%20cream%20and%20soft%20pink%20tones&width=1200&height=600&seq=carousel-06-campus&orientation=landscape',
    tag: '青春专题',
    title: '重返校园：青春剧全集心动回忆',
    desc: '从教室到操场，那些年我们一起追过的青春剧。和TA一起重温校园时光，感受最纯粹的悸动。',
    count: '35部青春',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
            专题聚焦
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            精心策划的追剧专题，帮你快速找到最适合情侣的好剧
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselData.map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              className="group bg-background-50 rounded-2xl overflow-hidden border border-secondary-200/70 transition-all hover:border-primary-200/60"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-full bg-black/30 text-white text-xs backdrop-blur-sm">
                  {item.count}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-bold text-foreground-800 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}